<template>
    <div id="arrows" class="mb-xl-5">
        <svg xmlns="http://www.w3.org/2000/svg" width="80.359" height="33.596" viewBox="0 0 80.359 33.596">
            <path class="a" id="arrow1"
                  d="M2349.06,487.586l14.743,8.729a3.746,3.746,0,0,0,3.757,0l14.742-8.729a3.688,3.688,0,1,0-3.758-6.346l-12.863,7.617-12.864-7.617a3.688,3.688,0,0,0-3.758,6.346Z"
                  transform="translate(-2325.501 -480.726)"/>
            <path class="a" id="arrow2"
                  d="M2290.074,500.122l36.494,21.609a3.75,3.75,0,0,0,3.757,0l36.493-21.609a3.688,3.688,0,0,0-3.758-6.346l-34.614,20.5-34.615-20.5a3.688,3.688,0,0,0-3.757,6.347Z"
                  transform="translate(-2288.266 -488.639)"/>
        </svg>
    </div>
</template>

<script>
    // eslint-disable-next-line no-unused-vars
    // const anime = require('animejs');

    import anime from 'animejs/lib/anime.es'

    export default {
        name: "Arrows",
        mounted() {
            // easing: 'steps(5)',
            window.addEventListener('DOMContentLoaded', () => {
                // anime({
                //     targets: '#arrows #arrow1',
                //     duration: 1000,
                //     opacity: [0, 1],
                //     easing: 'easeInCubic',
                //     direction: 'alternate',
                //     endDelay: 1000,
                //     loop: true,
                // });
                // anime({
                //     targets: '#arrows #arrow2',
                //     duration: 600,
                //     opacity: [0, 1],
                //     delay: 400,
                //     easing: 'easeInCubic',
                //     direction: 'alternate',
                //     endDelay: 1000,
                //     loop: true,
                // });


                // anime({
                //     targets: '#arrows #arrow1',
                //     // duration: 1000,
                //     opacity: [
                //         {value: 0, duration: 1000},
                //         {value: 1, duration: 1000},
                //     ],
                //     easing: 'easeOutCubic',
                //     direction: 'alternate',
                //     endDelay: 1000,
                //     loop: true,
                // });
                // anime({
                //     targets: '#arrows #arrow2',
                //     // duration: 600,
                //     opacity: [
                //         {value: 0, duration: 800},
                //         {value: 1, duration: 800},
                //     ],
                //     easing: 'easeOutCubic',
                //     direction: 'alternate',
                //     endDelay: 1000,
                //     delay: 400,
                //     loop: true,
                // });


                var tl = anime.timeline({
                    easing: 'easeInCubic',
                    loop: true,
                });
                tl
                    .add({
                        opacity: [0, 1],
                        targets: '#arrows #arrow1',
                        duration: 250
                    })
                    .add({
                        opacity: [0, 1],
                        targets: '#arrows #arrow2',
                        duration: 250
                    })
                    .add({
                        duration: 250
                    })
                    .add({
                        opacity: [1, 0],
                        targets: '#arrows #arrow2',
                        duration: 250
                    })
                    .add({
                        opacity: [1, 0],
                        targets: '#arrows #arrow1',
                        duration: 250
                    })
                    .add({
                        opacity: [0, 1],
                        targets: '#arrows #arrow1',
                        duration: 250
                    })
                    .add({
                        opacity: [0, 1],
                        targets: '#arrows #arrow2',
                        duration: 250
                    })
                    .add({
                        duration: 250
                    })
                    .add({
                        opacity: [1, 0],
                        targets: '#arrows #arrow2',
                        duration: 250
                    })
                    .add({
                        opacity: [1, 0],
                        targets: '#arrows #arrow1',
                        duration: 250
                    })
                    .add({
                        opacity: [0, 1],
                        targets: '#arrows #arrow1',
                        duration: 250
                    })
                    .add({
                        opacity: [0, 1],
                        targets: '#arrows #arrow2',
                        duration: 250
                    })
                    .add({
                        duration: 3000
                    })
                    .add({
                        opacity: [1, 0],
                        targets: '#arrows #arrow2',
                        duration: 250
                    })
                    .add({
                        opacity: [1, 0],
                        targets: '#arrows #arrow1',
                        duration: 250
                    })

            });
        }
    }
</script>

<style scoped>
    svg .a {
        fill: #fcca33;
    }
</style>

